import React from 'react';
import designSidebarUtils from 'src/utils/designSidebarUtils';
import HvSvg from 'src/components/HvSvg';
import utils from 'src/utils';
import {
  MenuItemContainer,
  MenuItemImage,
  MenuItemName,
  PaintbrushIconContainer,
} from './styled';

const { generateThumbnailURL, isBrandURL } = designSidebarUtils;
const { isPaintableBrickProvider } = utils.productCatalog;

const MenuItem = ({
  name,
  id,
  handleClick,
  isEditingProduct,
  isSelected,
  imageUrl,
  color,
  isLastItem,
}) => (
  <MenuItemContainer
    role="button"
    isSelected={isSelected}
    onClick={handleClick}
    isLastItem={isLastItem}
  >
    <MenuItemImage
      imageUrl={generateThumbnailURL(imageUrl)}
      color={color}
      isEditingProduct={isEditingProduct}
      data-selenium="menuItemImage"
      isBrand={isBrandURL(imageUrl)}
    >
      {isPaintableBrickProvider({ id }) ? (
        <PaintbrushIconContainer icon="paintbrush">
          <HvSvg
            src={require('src/assets/icons/ic-paintbrush.svg')}
            disabled={false}
          />
        </PaintbrushIconContainer>
      ) : null}
    </MenuItemImage>
    <MenuItemName data-selenium="menuItemNameText">{name}</MenuItemName>
  </MenuItemContainer>
);

export default MenuItem;
